import React from 'react';

import { ErrorBoundary } from '@nxte-nl/error-boundary';

import {
  ContentPageCard,
  Props as CardProps,
} from '../../components/ContentPageCard/ContentPageCard';
import { dataLayerHooks } from '../../hooks/dataLayerHooks/dataLayerHooks';

export type Props = Omit<CardProps, 'onClick'> & {
  id?: string;
  position: number;
};
export const ContentPageCardDataLayerContainer = React.memo((props: Props) => {
  const onClick = dataLayerHooks.useProductClickCallback({
    id: props.id || props.link.url.href,
    name: props.title,
    position: props.position,
  });

  return (
    <ErrorBoundary>
      <ContentPageCard {...props} onClick={onClick} />
    </ErrorBoundary>
  );
});

ContentPageCardDataLayerContainer.displayName = 'ContentPageCardDataLayerContainer';
